import HttpRequest from "@api/httpRequest";
import {RequestData} from "@models/axios";
import getPropByString from "@utils/get";

const getUrl = (): string => {
  return `/suppliers`
};

function api() {
  return {
    getList: (data: RequestData) => {
      const {params = {}} = data;
      return HttpRequest.get(getUrl(), {
        params: params
      });
    },
    
    create: (data: RequestData) => {
      return HttpRequest.post(getUrl(), data.payload, {});
    },
    
    update: (data: RequestData) => {
      const url = `${getUrl()}/${getPropByString(data, "params.id")}`;
      return HttpRequest.put(url, data.payload, {});
    },
    
    delete: (data: RequestData) => {
      const url = `${getUrl()}/${getPropByString(data, "params.id")}`;
      return HttpRequest.delete(url, {});
    },
    
    getItem: (data: RequestData) => {
      const url = `${getUrl()}/${getPropByString(data, "params.id")}`;
      return HttpRequest.get(url);
    },
  
    fetchPayments: (data: RequestData) => {
      const {params = {}} = data;
      const url = `${getUrl()}/${getPropByString(data, "params.supplier_id")}/payments`;
      return HttpRequest.get(url, {
        params: params
      });
    },
    
    addPayment: (data: RequestData) => {
      const {params = {}} = data;
      const url = `${getUrl()}/${getPropByString(data, "params.supplier_id")}/payments`;
      return HttpRequest.post(url, data.payload);
    },
  
    getPaymentById: (data: RequestData) => {
      const {params = {}} = data;
      const url = `${getUrl()}/${getPropByString(data, "params.supplier_id")}/payments/${params.id}`;
      return HttpRequest.get(url);
    },
    
    updatePayment: (data: RequestData) => {
      const {params = {}} = data;
      const url = `${getUrl()}/${getPropByString(data, "params.supplier_id")}/payments/${params.id}`;
      return HttpRequest.put(url, data.payload);
    },
    
    fetchStats: (data: RequestData) => {
      const {params = {}} = data;
      const url = `${getUrl()}/${getPropByString(data, "params.supplier_id")}/stats`;
      return HttpRequest.get(url, {
        params: params
      });
    },
  };
}

export default api();
